export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    order_routing = 'order_routing',
    automations = 'automations',
    order_sync_conditions = 'order_sync_conditions',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [
        AvailableToggleFeatures.automations,
        AvailableToggleFeatures.order_routing,
        AvailableToggleFeatures.order_sync_conditions,
    ],
    [ENV_LIST.STAGING]: [],
    [ENV_LIST.REVIEW_APP]: [
        AvailableToggleFeatures.automations,
        AvailableToggleFeatures.order_routing,
        AvailableToggleFeatures.order_sync_conditions,
    ],
    [ENV_LIST.DEMO_01]: [],
    [ENV_LIST.SANDBOX]: [],
    [ENV_LIST.PRODUCTION]: [],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
